let index: number = 0;

const InvoiceCashOrderGridPluginSettings: IPluginSettings = {
    name: 'Приходный кассовый ордер',
    mnemocode: 'invoice_cash_order_plugin',
    permission: 'InvoiceCashOrder',
    columns: [
        {
            order: index++,
            propertyName: "idGlobal",
            propertyType: "string",
            displayName: "ИД",
            visibility: false,
            width: 200,
        },
        {
            order: index++,
            propertyName: "contractorFromName",
            propertyType: "string",
            displayName: "От кого",
            visibility: true,
            width: 100,
        },
        {
            order: index++,
            propertyName: 'retailSumIncVat',
            propertyType: 'number',
            displayName: 'Сумма',
            visibility: true,
            width: 150
        },
        {
            order: index++,
            propertyName: "dateCreated",
            propertyType: "datetime",
            displayName: "Дата создания",
            visibility: true,
            width: 100,
        },
        {
            order: index++,
            propertyName: "dateModified",
            propertyType: "datetime",
            displayName: "Дата изменения",
            visibility: false,
            width: 100,
        },
        {
            order: index++,
            propertyName: "dateDeleted",
            propertyType: "datetime",
            displayName: "Дата удаления",
            visibility: false,
            width: 100,
        },
        {
            order: index++,
            propertyName: "documentDate",
            propertyType: "date",
            displayName: "Дата документа",
            visibility: true,
            width: 100,
        },
        {
            order: index++,
            propertyName: "documentState",
            propertyType: "string",
            displayName: "Статус документа",
            visibility: true,
            width: 100,
        },
        {
            order: index++,
            propertyName: "documentStateModified",
            propertyType: "datetime",
            displayName: "Последняя смена статуса",
            visibility: false,
            width: 100,
        },
        {
            order: index++,
            propertyName: "mnemocode",
            propertyType: "string",
            displayName: "Мнемокод",
            visibility: true,
            width: 100,
        },
        {
            order: index++,
            propertyName: "supplierSum",
            propertyType: "number",
            displayName: "Сумма без НДС, пост.",
            visibility: true,
            width: 100,
        },
        {
            order: index++,
            propertyName: "supplierVatSum",
            propertyType: "number",
            displayName: "Сумма НДС, пост.",
            visibility: true,
            width: 100,
        },
        {
            order: index++,
            propertyName: "supplierSumIncVat",
            propertyType: "number",
            displayName: "Сумма с НДС, пост.",
            visibility: true,
            width: 100,
        },
        {
            order: index++,
            propertyName: "retailSum",
            propertyType: "number",
            displayName: "Сумма без НДС, розн.",
            visibility: true,
            width: 100,
        },
        {
            order: index++,
            propertyName: "retailVatSum",
            propertyType: "number",
            displayName: "Сумма НДС, розн.",
            visibility: true,
            width: 100,
        }
    ]
}
export default InvoiceCashOrderGridPluginSettings